import React, { useCallback } from 'react';

import Input from '../../../components/Input';
import { StyledEditableDistanceFields } from './EditableDistanceFields.Styles';

interface IDistanceFieldsProps {
  feet: number;
  inches: number;
  editMode?: boolean;
  setFeet?: (feet: number) => void;
  setInches?: (inches: number) => void;
}

type IProps = IDistanceFieldsProps;

export const EditableDistanceFields: React.FunctionComponent<IProps> = props => {
  const { feet, inches, editMode, setFeet, setInches } = props;

  const setValue = useCallback(
    (setter: typeof setFeet | typeof setInches) => (eventa: any) => {
      if (setter) {
        setter(eventa.target.value);
      }
    },
    [setFeet]
  );

  return (
    <StyledEditableDistanceFields>
      <div className="field">
        <div className="number-container">
          {editMode ? (
            <Input type="number" value={feet} onChange={setValue(setFeet)} fullWidth={true} />
          ) : (
            <span>{feet}</span>
          )}
        </div>
        <span className="unit">ft.</span>
      </div>

      <div className="field">
        <div className="number-container">
          {editMode ? (
            <Input type="number" value={inches} onChange={setValue(setInches)} fullWidth={true} />
          ) : (
            <span>{inches}</span>
          )}
        </div>
        <span className="unit">in.</span>
      </div>
    </StyledEditableDistanceFields>
  );
};
